import { HTMLAttributes } from 'react'
import SelectBox from '~components/ui/text-input/select-box'
import Pet from '~models/pet'
import { GENDER_DATA, NEUTERED_SELECT_LIST } from '~utils/pet-data'
import convertPetGender from '~utils/pet/convert-pet-gender'

interface Props extends HTMLAttributes<HTMLDivElement> {
  gender: Pet.Gender | null
  onGenderSelect: (gender: Pet.Gender) => void
  onNeuteredStatusSelect: (status: boolean) => void
  isNeutered?: boolean | null
}

const PetGender = ({
  gender,
  isNeutered,
  onGenderSelect,
  onNeuteredStatusSelect,
  ...props
}: Readonly<Props>) => {
  const neuteredStatusString =
    typeof isNeutered === 'boolean' ? (isNeutered ? 'Neutered or spayed' : 'Intact') : 'Unknown'
  const initialNeuteredStatus = isNeutered !== null ? neuteredStatusString : ''

  return (
    <div className={props.className}>
      <SelectBox className="w-full lg:w-full">
        <SelectBox.Input
          placeholder="Select gender"
          value={gender !== null ? convertPetGender(gender, 'informal') : null}
          validateErrorMessage={value => {
            if (value === null) return 'Please select gender'
            return ''
          }}
        />
        <SelectBox.Dropdown>
          <SelectBox.DropdownItemGroup
            data={GENDER_DATA}
            onItemClick={item => {
              onGenderSelect(item.value as Pet.Gender)
            }}
          />
        </SelectBox.Dropdown>
      </SelectBox>

      <SelectBox className="mt-4 w-full lg:w-full">
        <SelectBox.Input
          validateErrorMessage={value => {
            if (value === '') return 'Please select spay/neuter status'
            return ''
          }}
          placeholder="Select status"
          value={initialNeuteredStatus}
        />
        <SelectBox.Dropdown>
          <SelectBox.DropdownItemGroup
            data={NEUTERED_SELECT_LIST}
            onItemClick={item => onNeuteredStatusSelect(Boolean(item.value))}
          />
        </SelectBox.Dropdown>
      </SelectBox>
    </div>
  )
}

export default PetGender
